import * as d3 from "d3";
import { Directive, Input } from "@angular/core";
import { GraphStateService } from "../../core-module/services/state/graph-state.service";
import {
  checkCloInputRange,
  collapseNonInterpolationData,
  renderCloGraph,
} from "../graph-utils/clo-graph-render";

/**
 * Shared base class for CloGraphComponent and CloLiteGraphComponent.
 * Contains all duplicate graph setup/teardown logic.
 */
@Directive()
export abstract class CloGraphBase {
  @Input() readOnly = true;

  title = "linechartDemo";

  inputXRange = [0, 120];
  inputYRange = [0, 100];

  data: LegacyAny[] = [
    { hour: 0, power: 30 },
    { hour: 20, power: 55 },
    { hour: 50, power: 65 },
    { hour: 60, power: 45 },
    { hour: 90, power: 80 },
    { hour: 120, power: 100 },
  ];
  focus;
  drag;

  public margin = { top: 50, right: 50, bottom: 50, left: 50 };
  public width: number;
  public height: number;
  public x: LegacyAny;
  public y: LegacyAny;
  public svg2: LegacyAny;
  public line: d3.Line<[number, number]>;
  public area: d3.area<[number, number]>;
  public id = "lineChart";
  public color1 = "#00b36b";
  graphDisabled;
  graphType;
  subscription;
  successfullDrag = false;

  protected abstract get graphState(): GraphStateService;

  public buildSvg() {
    this.svg2 = d3.select("#svg2");
    this.width = 500 - this.margin.left - this.margin.right;
    this.height = 500 - this.margin.top - this.margin.bottom;
  }

  public addXandYAxis() {
    this.x = d3.scaleLinear().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.x.domain(this.inputXRange);
    this.y.domain(this.inputYRange);
  }

  protected applyRenderedGraph(dataSource: LegacyAny[], yLabelX: number) {
    const rendered = renderCloGraph(dataSource, {
      color1: this.color1,
      xRange: this.inputXRange,
      yRange: this.inputYRange,
      readOnly: this.readOnly,
      yLabelX,
    });
    this.svg2 = rendered.svg2;
    this.width = rendered.width;
    this.height = rendered.height;
    this.x = rendered.x;
    this.y = rendered.y;
    this.focus = rendered.focus;
  }

  public addDrag() {
    if (this.readOnly) {
      return;
    }
  }

  dragstarted() {
    return this;
  }

  make_x_gridlines() {
    return d3.axisBottom(this.x).ticks(10);
  }

  make_y_gridlines() {
    return d3.axisLeft(this.y).ticks(10);
  }

  protected expandNonInterpolationData(): void {
    if (this.graphType === "Non-Interpolation") {
      const dataLeangth = this.data.length;
      const newData = [];
      let j = 0;
      for (let i = 0; i < dataLeangth; i++) {
        newData[j] = {
          hour: this.data[i].hour,
          power: this.data[i].power,
        };
        if (i + 1 < dataLeangth) {
          newData[j + 1] = {
            hour: this.data[i + 1].hour,
            power: this.data[i].power,
          };
        }
        j = j + 2;
      }
      this.data = newData;
    }
  }

  protected collapseAndValidate(showAlert: boolean): LegacyAny[] {
    const newArrayData = this.graphType === "Non-Interpolation"
      ? collapseNonInterpolationData(this.data)
      : this.data;
    this.graphState.sendGraphValidData("valid");
    checkCloInputRange(
      this.data,
      this.data,
      this.inputXRange,
      this.inputYRange,
      () => this.graphState.sendGraphValidData("invalid"),
      showAlert
    );
    return newArrayData;
  }
}
